import { Form, FormInstance } from 'antd';
import { forwardRef, Ref, useImperativeHandle } from 'react';
import refine from 'utils/refine';

export interface ForwardFormInstanceProps {
  children: (form: FormInstance<any>) => React.ReactNode;
}

/**
 * 快速应对某些使用Modal嵌套Form 的场景下，在父级声明的useForm()实例无法正确重置intialValues的情况
 * @returns
 */
const ForwardFormInstance = <V extends Record<string, any>>(
  { children }: ForwardFormInstanceProps,
  ref: Ref<FormInstance<V>>,
) => {
  const [inst] = Form.useForm<V>();
  useImperativeHandle(ref, () => {
    return inst;
  });
  return <>{refine(children, inst)}</>;
};
export default forwardRef<FormInstance<any>, ForwardFormInstanceProps>(ForwardFormInstance);
